
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Container } from "react-bootstrap";
import { QueryListProvider } from "../../../component/solution/QueryList/QueryListContext";
import { QueryList } from "../../../component/solution/QueryList/QueryList";

export const PurchaseInvoice: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                <QueryListProvider>
                    <QueryList
                        listTitle={"Purchase Invoices"}
                        recordTitle={"Purchase Invoice"}
                        tableName={"sa_purchase_invoice"}
                        editTableName={"sa_purchase_invoice"}
                        editHasCompoundKey={false}
                        join={[]} 
                        select={[
                            // {
                            //     fullColumnName: "item_code",
                            //     aggregate: ""
                            // }
                        ]}
                        where={[
                            // {
                            //     fullColumnName: "is_base_item",
                            //     value: false,
                            //     operator: "EQ",
                            //     cast: CastType.BOOLEAN
                            // }
                        ]} 
                        orderBy={[    
                        //     {
                        //     fullColumnName: "item_code",
                        //     direction: "ASC",
                        //     cast: CastType.STRING
                        // }
                    ]} 
                        groupBy={[]}                   
                    />
                </QueryListProvider>
            </Container>
        </React.Fragment>
    );
}